import BootstrapVue from 'bootstrap-vue'
import Murmur from '@icij/murmur'
import Vue from 'vue'
import VueGtag from 'vue-gtag'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import VueScrollactive from 'vue-scrollactive'
import VueScrollTo from 'vue-scrollto'
import VueWait from 'vue-wait'
import { library as fortawesome } from '@fortawesome/fontawesome-svg-core'

import * as icons from '@/utils/font-awesome'
import { routes, guards } from './router'
import './main.scss'

// Autoload images from Murmur
require.context('@icij/murmur/dist/lib/img/', true)

Vue.config.productionTip = false

Murmur.config.set('project.name', 'Shadow Diplomats')
Murmur.config.set('app.name', 'Charts')
Murmur.config.set('app.url', 'https://projects.icij.org/investigations/shadow-diplomats/charts')
Murmur.config.set('sharing-options.title', 'Shadow Diplomats')

// Register exported icons
fortawesome.add(...Object.values(icons))

Vue.use(BootstrapVue)
Vue.use(Murmur)
Vue.use(VueI18n)
Vue.use(VueRouter)
Vue.use(VueScrollactive)
Vue.use(VueScrollTo)
Vue.use(VueWait)

const wait = new VueWait()
const config = Murmur.config
const mode = 'history'
const router = guards({ router: new VueRouter({ routes, mode }), config })
const render = h => h('div', { attrs: { id: 'app' } }, [
  h('RouterView', { props: { name: 'header' } }),
  h('RouterView'),
  h('RouterView', { props: { name: 'footer' } })
])

// Configure Google Analytics
Vue.use(VueGtag, {
  config: {
    id: 'G-1SGQ09WGJS',
    pageTrackerScreenviewEnabled: true,
    pageTrackerTemplate (route) {
      return {
        page_path: '/shadow-diplomats/charts' + route.path,
        page_title: document.title,
        page_location: window.location.href
      }
    }
  }
}, router)

// Create a mount the main Vue instance
new Vue({ router, render, wait }).$mount('#app')
